import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';
import BinsPage from './pages/BinsPage';
import UsersPage from './pages/UsersPage';
import SettingsPage from './pages/SettingsPage';
import LogsPage from './pages/LogsPage';
import SitesPage from './pages/SitesPage';
import FileManagementPage from './pages/FileManagementPage';
import DocsPage from './pages/DocsPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
  <Route path="/register" element={<Navigate to="/login" replace />} />
        
        {/* Routes with the new Layout */}
        <Route 
          path="/" 
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        >
          <Route index element={<Navigate to="/bins" replace />} />
          <Route path="bins" element={<BinsPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="sites" element={<SitesPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="logs" element={<LogsPage />} />
          <Route path="file-management" element={<FileManagementPage />} />
          <Route path="docs" element={<DocsPage />} />
        </Route>

      </Routes>
    </Router>
  );
}

export default App;
